module.exports = __webpack_public_path__ + "img/cns_printer_mac18.7186e409.png";